/**
 * 导出单位设置，主要用在全局配置里面
 */
export const unit={
    "Flux":{
        name:"Flux",
        values:["CMS","CMH","LPS"], // 可选值
        default:"CMS", // 默认值
        title:"流量", // 中文名称
    },
    "Presss":{
        name:"Presss",
        values:["M","MPA","KPA"], // 可选值
        default:"M", // 默认值
        title:"压强", // 中文名称
    },
    "Temp":{
        name:"Temp",
        values:["°C"], // 可选值
        default:"°C", // 默认值
        title:"温度", // 中文名称
    },
}

/**
 * 导出水文件的格式 
 */
export const water={
    // 公共部分
    "public": {
		"header": [
			"medium"
		],
		"data": [
			[
				"water"
			]
		]
	},
	"unit": {
		"header": ["Flux","Press","Temp"],
		"data": [["CMH","M","°C"]]
	},
    // 属性数据
    "node": {
       "header": ["id","elevation"],
       "data": []
    },
    "reservior": {
        "header": ["id","elevation"],
        "data": []
    },
    "tank": {
        "header": ["id","elevation"],    
        "data": []
    },
    "pipe": {
        "header": ["id","node1","node2","length","diameter","roughness","localResCoeff"],
        "data": []
    },
    "valve": {
        "header": ["id","node1","node2","diameter","type","setting","minorloss"],
        "data": []
    },
    // 绘图信息
    "pipescoor":{
        "header":[
            "id","node1","node2","f-x-coord","f-y-coord","l-x-coord","l-y-coord"
        ],
        "data": [],
    },
    "nodescoor":{
        "header": [
            "node_id","node_type","type","x-coord","y-coord"
        ],
        "data":[],
    },
    "devicescoor":{
        "header": [
            "pipe_id","dev_id","type","x-coord","y-coord"
        ],
        "data": [],
    }
}
/**
 * 导出保温水文件的格式 
 */
 export const insulationWater={
    // 公共部分
    "public": {
		"header": [
			"medium"
		],
		"data": [
			[
				"water"
			]
		]
	},
	"unit": {
		"header": ["Flux","Press","Temp"],
		"data": [["CMH","M","°C"]]
	},
    // 属性数据
    "node": {
       "header": ["id","elevation"],
       "data": []
    },
    "reservior": {
        "header": ["id","elevation"],
        "data": []
    },
    "tank": {
        "header": ["id","elevation"],    
        "data": []
    },
    "pipe": {
        "header": ["id","node1","node2","length","diameter","roughness","localResCoeff","pipeThick","layerMethod","insulaSchemeId"],
        "data": []
    },
    "valve": {
        "header": ["id","node1","node2","diameter","type","setting","minorloss"],
        "data": []
    },
    // 保温材料
    "insulaMaterial": {
        "header": ["insulaTypeId","name","tMax","lambda0","A1","A0","B1","B0","C1","C0","unitPrice"],
        "data": [
          [1, "空气",0,0.0242, 0, 0, 0, 0, 0, 0,0],
          [2, "橡塑",100,0.033,0.0,0,0.0,0,0,0,300],        
          [3, "聚氨酯",120,0.035,0.0,0,0.0,0,0,0,650],        
          [4, "玻璃棉",400,0.042,0.00017,70,0,0,0,0,800],        
          [5, "岩棉", 500, 0.044, 0,0,0,0,0,0,950],
          [5, "珍珠岩",600,0.065,0.00012,70,0,0,0,0,185],  
          [6, "硅酸盐",600,0.065,0.00017,70,0,0,0,0,150],
          [7, "纳米气凝胶",650,0.0172,3E-5,0,1.5E-8,0,2.7E-10,0,10000],
          [8, "硅酸钙",650,0.062,0.00011,70,0,0,0,0,1400],        
          [9, "硅酸铝",800,0.056,0.0002,70,0,0,0,0,1500]
        ]
    },
    // 保温方案
    "insulaScheme":{
        "header":["insulaSchemeId","insulaNum","insulaTypeId1","insulaThick1","insulaTypeId2","insulaThick2","insulaTypeId3",
            "insulaThick3","insulaTypeId4","insulaThick4"],
        "data":[
          [1,2,3,50,2,50],  
          [2,2,3,50,2,50]
        ]
    },
    // 绘图信息
    "pipescoor":{
        "header":[
            "id","node1","node2","f-x-coord","f-y-coord","l-x-coord","l-y-coord"
        ],
        "data": [],
    },
    "nodescoor":{
        "header": [
            "node_id","node_type","type","x-coord","y-coord"
        ],
        "data":[],
    },
    "devicescoor":{
        "header": [
            "pipe_id","dev_id","type","x-coord","y-coord"
        ],
        "data": [],
    }
}


/** 蒸汽导出文件格式  */
export const steam={
    // 公共部分
    "public": {
		"header": [
			"medium"
		],
		"data": [
			[
				"steam"
			]
		]
	},
    "pipes":{
        "header":[
            "id","node1","node2","f-x-coord","f-y-coord","l-x-coord","l-y-coord"
        ],
        "data": [],
        "properities":{}
    },
    "nodes":{
        "header": [
            "node_id","node_type","x-coord","y-coord"
        ],
        "data":[],
        "properities":{}
    },
    "devices":{
        "header": [
            "pipe_id","dev_id","x-coord","y-coord"
        ],
        "data": [],
        "properities":{}
    }
}
/** 保存图形的json */
export const draw={
    type:"draw",
    "pipes":{
        "header":[
            "id","node1","node2","f-x-coord","f-y-coord","l-x-coord","l-y-coord"
        ],
        "data": [],
        "properities":{}
    },
    "nodes":{
        "header": [
            "node_id","node_type","x-coord","y-coord"
        ],
        "data":[],
        "properities":{}
    },
    "devices":{
        "header": [
            "pipe_id","dev_id","x-coord","y-coord"
        ],
        "data": [],
        "properities":{}
    }
}

/**
 * 保温材料
 */
export const insulaMaterial={
    "header": [
        "insulaTypeId","name","tMax","lambda0","A1","A0","B1","B0","C1","C0","unitPrice"
    ],
    "data": []
}

/**
 * 保温方案
 */
export const insulaScheme={
    "header":[  
            "insulaSchemeId","insulaNum","insulaTypeId1","insulaThick1","insulaTypeId2","insulaThick2","insulaTypeId3","insulaThick3",
            "insulaTypeId4","insulaThick4"
    ],
    "data":[]
}